import React, { useState, useEffect } from 'react';
import List from './List';
import Alert from './Alert';

const getLocalStorage = ()=>
{
  let list = localStorage.getItem('list');
  if(list)
  {
    return JSON.parse(localStorage.getItem('list'));
  }
  else
  {
    return []
  }
}


const App = ()=>
{
  const [ name, setName ] = useState('');
  const [ list, setList ] = useState(getLocalStorage());
  const [ isEditing, setIsEditing ] = useState(false);
  const [ alert, setAlert ] = useState({ show : false, msg : '', type : '' });
  const [ editID, setEditID ] = useState(null);
  const showAlert = ( show = false, msg = '', type = '' )=>
  {
    setAlert({show, msg, type});
  }

  const handleSubmit = (e)=>
  {
    e.preventDefault();
    if(!name)
    {
      showAlert(true, 'Please Enter Value', 'danger');
    }
    else if(name && isEditing)
    {
      setList(
        list.map((item) => {
          if (item.id === editID) {
            return { ...item, title: name };
          }
          return item;
        })
      );
      setName('');
      setEditID(null);
      setIsEditing(false);
      showAlert(true, 'value changed', 'success');
    }
    else
    {
      showAlert(true, 'Item Added To The List', 'success');
      const newItem = { id : new Date().getTime().toString(), title : name };
      setList([...list, newItem]);
      setName('');
    }
  }

  const clearItems = ()=>
  {
    showAlert(true, 'Empty List', 'danger');
    setList([]);
  }

  const removeItem = (id)=>
  {
    showAlert(true, 'Item Removed', 'danger');
    const newList = list.filter((item)=>
    { 
      return item.id !== id;
    })
    setList(newList);
  }

  const editItem = (id) => 
  {
    const specificItem = list.find((item) => item.id === id);
    setIsEditing(true);
    setEditID(id);
    setName(specificItem.title);
  }

  useEffect(()=>
  {
    localStorage.setItem('list', JSON.stringify(list));
  }, [list])

  return (
  <section className='section-center'>
    <form class="grocery-form" onSubmit={handleSubmit}>
      { alert.show && <Alert {...alert} removeAlert = {showAlert} list = {list} /> }
      <h3>Grocery Bud</h3>
      <div className = "form-control">
        <input type = "text" className = 'grocery' placeholder = 'e.g. eggs' value = {name} onChange={(e)=>{setName(e.target.value)}} />
        <button type = 'submit' className = 'submit-btn'>
          { isEditing ? 'Edit' : 'Add' }
        </button>
      </div>
    </form>
    {
      list.length > 0 && (
      <div className = "grocery-container">
        <List items = {list} removeItem = {removeItem} editItem = {editItem} />
        <button className='clear-btn' onClick = {clearItems}>Clear Items</button>
      </div>) 
    }
  </section>);
}

export default App;
